module.exports = __webpack_public_path__ + "img/pause-fill.825a0792.svg";